import React, { useEffect, useRef, useState } from 'react';
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField,
} from '@mui/material';

// Boîte de dialogue de formulaire simple (création / modification).
// fields : [{ name, label, required?, multiline?, options?: [{ value, label }] }]
// description : texte au-dessus des champs ; danger : bouton de validation rouge (action irréversible).
// onSubmit(values) renvoie une promesse ; une erreur est affichée dans la boîte, qui reste ouverte.
export default function FormDialog({
  open, title, description, fields, initialValues = {}, submitLabel = 'Save', danger = false, onSubmit, onClose,
}) {
  const [values, setValues] = useState(initialValues);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const firstInput = useRef(null);
  const [selectFirst, setSelectFirst] = useState(false);

  useEffect(() => {
    if (open) { setValues(initialValues); setError(null); setSaving(false); setSelectFirst(true); }
  }, [open]);
  // Premier champ sélectionné une fois rempli (renommage : taper par-dessus l'ancien nom).
  useEffect(() => {
    if (!selectFirst || !firstInput.current) return;
    firstInput.current.select();
    setSelectFirst(false);
  }, [selectFirst, values]);

  const missing = fields.some(f => f.required && !String(values[f.name] || '').trim());

  const submit = async e => {
    e.preventDefault();
    if (missing || saving) return;
    setSaving(true);
    setError(null);
    try {
      await onSubmit(values);
      onClose();
    } catch (err) {
      setError(err.code === 'permission-denied' ? "You don't have permission for this action." : err.message);
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="sm">
      <form onSubmit={submit}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {description && <p style={{ marginTop: 0 }}>{description}</p>}
          {fields.map((f, i) => (
            <TextField
              key={f.name} label={f.label} required={f.required} autoFocus={i === 0}
              select={!!f.options} multiline={f.multiline} minRows={f.multiline ? 3 : undefined}
              value={values[f.name] ?? ''} onChange={e => setValues({ ...values, [f.name]: e.target.value })}
              inputRef={i === 0 && !f.options ? firstInput : undefined}
              fullWidth margin="dense"
            >
              {(f.options || []).map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
            </TextField>
          ))}
          {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={saving}>Cancel</Button>
          {/* Rouge imposé en ligne : SignIn/styles.css noircit tous les button[type=submit]. */}
          <Button type="submit" variant="contained" disableElevation disabled={missing || saving}
            color={danger ? 'error' : 'primary'}
            style={danger && !(missing || saving) ? { backgroundColor: 'rgb(211, 47, 47)' } : undefined}>
            {submitLabel}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
